export const messages = {
  noPermissionsForCurrentUser: 'No permissions for current User.',
};
